import React, { useEffect, useState } from "react";
import { Col, Row, Select, Table, Spin, message } from "antd";
import axios from "axios";
import WebsocketApi from "../Layout/WebSocketApi";


const BalanceFundSpot = (props) => {
  const [secondApiData, setSecondApiData] = useState(null);
  const [CheckBal, setCheckBal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [option, setOption] = useState([]);
  const [option2, setOption2] = useState(option);
  const [Api, setApi] = useState();
  const { type, apiKey,apiSecret,selectedapi } = props?.data;
  const sortedTableData = WebsocketApi();

  // const checkSpotBalance = () => {
  //   setCheckBal(null);
  //   setLoading(true);
  //   const token = localStorage.getItem("jwt");
  
  //   const secondApiData = {
  //     request_type: "private", // assuming it's a private request
  //     method: "GET", // assuming the method is POST
  //     key: apiKey,
  //     secret: apiSecret,
  //     endpoint: "/api/v3/account",
  //     params:{
  //       omitZeroBalances: "true",
  //     }

  //       axios({
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         url: process.env.REACT_APP_API_ALLCOINS + "/make_request", // Change this to the actual second API URL
  //         data: secondApiData,
  //       })
  //         .then((secondRes) => {
  //           setLoading(false);
  //           setSecondApiData(secondRes.data); // Store the second API response in state
           
  //         })
  //         .catch((err) => {
  //           setLoading(false);
  //           console.error("Error from second API:", err);
  //         });
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       // message.error(err?.response?.data?.Error)
  //     });
  // };

  const checkSpotBalance = () => {
    setCheckBal(null);
    setLoading(true);
    const token = localStorage.getItem("jwt");
  
    const secondApiData = {
      request_type: "private",
      method: "GET",  
      key: apiKey,
      secret: apiSecret,
      endpoint: "/api/v3/account",
      params: {
        omitZeroBalances: "true",
      }
    };
  
    axios({
      method: "POST", 
      headers: { "Content-Type": "application/json" },
      url: process.env.REACT_APP_API_ALLCOINS + "/make_request",
      data: secondApiData,
    })
      .then((secondRes) => {
        setLoading(false);
        setSecondApiData(secondRes.data); 
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error from second API:", err);
      });
  };
  
  

  useEffect(() => {
    if(selectedapi){
      checkSpotBalance();
    }
  
  }, [selectedapi]);

  useEffect(() => {
    setOption2(option);
    const fisrtLabel = option[0]?.label;
    setApi(fisrtLabel);
  }, [option]);


  const columns = [
    {
      title: <p className="p-1 text-center ">Assets</p>,
      dataIndex: "asset",
      key: "asset",
    },
    {
      title: <p className="p-1 text-center ">Quantity</p>,
      dataIndex: "free",
      key: "free",
    },
    {
      title: <p className="p-1 text-center ">Price</p>,
      dataIndex: "currentPrice",
      key: "currentPrice",
    },
    {
      title: <p className="p-1 text-center ">Value</p>,
      dataIndex: "locked",
      key: "locked",
    },
  ];

  const dataSource = secondApiData?.Success?.balances?.length > 0
  ? secondApiData.Success.balances.map((balance) => {
      const symbolWithoutUSDT = balance.asset;

      const currentPrice = symbolWithoutUSDT === "USDT" ? 1 : 
        sortedTableData.find((data) => data.name === symbolWithoutUSDT)?.price || 0;

      const calculatedLocked = currentPrice * parseFloat(balance.free);

      return {
        asset: <p className="p-1 rounded-lg text-center">{balance.asset}</p>,
        free: <p className="p-1 rounded-lg text-center">{balance.free}</p>,
        currentPrice: <p className="p-1 rounded-lg text-center">{currentPrice}</p>,
        locked: (
          <p className="p-1 rounded-lg text-center">
            {calculatedLocked.toFixed(2)} 
          </p>
        ),
      };
    })
  : [
      {
        asset: <p className="p-1 rounded-lg text-center">*****</p>,
        free: <p className="p-1 rounded-lg text-center">*****</p>,
        currentPrice: <p className="p-1 rounded-lg text-center">*****</p>,
        locked: <p className="p-1 rounded-lg text-center">*****</p>,
      },
    ];

  
  

  return (
    <div>
      {/* <Select
                value={Api}
                className='focus:border-colorAccent hover:border-colorAccent'
                style={{
                    width: 180,
                }}
                placeholder="Select API Name"
                onChange={handleChange}
                options={option2}
            /> */}
      {/* <div className=' px-5 pb-4'>
                <span className=' text-sm md:text-base font-semibold'>API Name : </span>
                <Select
                    value={Api}
                    className='focus:border-colorAccent hover:border-colorAccent'
                    style={{
                        width: 180,
                    }}
                    placeholder="Select API Name"
                    onChange={handleChange}
                    options={option2}
                />
            </div> */}

      <div>
        <Row>
          <Col xs={24}>
            <Spin spinning={loading}>
              <Table
                size="medium"
                columns={columns}
                className=""
                dataSource={dataSource}
                pagination={false}
              />
            </Spin>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default BalanceFundSpot;
